import { render, staticRenderFns } from "./Scene0.vue?vue&type=template&id=3cb6aba7&scoped=true"
import script from "./Scene0.vue?vue&type=script&lang=js"
export * from "./Scene0.vue?vue&type=script&lang=js"
import style0 from "./Scene0.vue?vue&type=style&index=0&id=3cb6aba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb6aba7",
  null
  
)

export default component.exports